"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _polished = require("polished");

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MultiImageUpload = ({
  name,
  value,
  required,
  setValue,
  classes
}) => _react.default.createElement("div", {
  className: classes.root
}, value && value.map((item, index) => _react.default.createElement("div", {
  className: classes.item,
  key: index
}, _react.default.createElement("div", {
  className: classes.imageWrapper
}, _react.default.createElement("img", {
  src: item.data || item,
  className: classes.image,
  alt: "Uploaded file ".concat(index)
}), _react.default.createElement("div", {
  className: classes.delete,
  onClick: () => setValue(name, value.filter((subItem, subIndex) => subIndex !== index), required)
}, "x")))), _react.default.createElement("div", {
  className: classes.item
}, _react.default.createElement("input", {
  accept: "image/*",
  className: classes.input,
  id: name,
  multiple: true,
  type: "file",
  onChange: e => {
    let oldValue = value || [];
    Object.values(e.target.files).forEach(value => {
      const fileReader = new FileReader();
      const fileName = value.name,
            fileType = value.type;
      const dataFile = value;
      fileReader.readAsDataURL(value);

      fileReader.onload = () => {
        const data = fileReader.result;
        setValue(name, [...oldValue, {
          fileName,
          type: fileType.split('/')[0],
          data,
          dataFile
        }], required);
        oldValue = [...oldValue, {
          fileName,
          type: fileType.split('/')[0],
          data,
          dataFile
        }];
      };
    });
  }
}), _react.default.createElement("label", {
  htmlFor: name,
  className: (0, _classnames.default)(classes.imageWrapper, classes.label)
}, "Add more")));

MultiImageUpload.defaultProps = {
  columns: 4
};

var _default = (0, _.withFormControl)((0, _reactJss.default)(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: -10
  },
  item: {
    maxWidth: '50%',
    minWidth: '50%',
    padding: 10,
    boxSizing: 'border-box',
    [(0, _.breakpoint)(theme.breakpoints.md)]: {
      maxWidth: props => "".concat(100 / props.columns, "%"),
      minWidth: props => "".concat(100 / props.columns, "%")
    }
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.fill,
    padding: 15,
    height: '33vw',
    position: 'relative',
    [(0, _.breakpoint)(theme.breakpoints.md)]: {
      height: '20vw'
    },
    [(0, _.breakpoint)(theme.breakpoints.lg)]: {
      height: '12vw',
      maxHeight: 300
    }
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  delete: {
    position: 'absolute',
    top: 0,
    right: 0,
    lineHeight: 'normal',
    fontSize: 16,
    padding: 5,
    cursor: 'pointer',
    '&:hover': {
      color: theme.colors.inputBorder
    }
  },
  input: {
    display: 'none'
  },
  label: {
    display: 'flex',
    flexDrection: 'column',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.inputText,
    '&:hover': {
      backgroundColor: (0, _polished.lighten)(0.04, theme.colors.fill)
    }
  }
}))(MultiImageUpload));

exports.default = _default;